export default __webpack_public_path__ + "static/media/greeting19.73823b80.png";